import angular from "angular"
import { ReportBatchDownloaderController } from './controller'

export const vsName: string = 'reportBatchDownloader'

const template: string = require('./index.html')

export function reportBatchDownloaderDirectiveFactory(): angular.IDirective {
  return {
    templateUrl: template,
    restrict: 'E',
    transclude: false,
    controller: ReportBatchDownloaderController,
    controllerAs: 'ctrl',
    bindToController: {
      reportGroup: '=',
      items: '=',
      itemToIdMap: '='
    },
    scope: {}
  }
}
reportBatchDownloaderDirectiveFactory.$inject = [] as string[]